function adjustIntercomPosition() {
  if (document.getElementById("sticky-actions") !== null) {
    $(".courses").addClass("sticky-present")
  }
}

$(function () {
  adjustIntercomPosition()
})
